import { Card } from '@loadsmart/loadsmart-ui'
import FileViewer from 'molecules/FileViewer/FileViewer'
import { useEffect, useState } from 'react'
import X12SchemaGenerator from './X12SchemaManager'
import { safeBase64Encode, safeBase64Decode } from '../../../common/helpers/encoding'

export interface DataModelSchemaStructureProps {
  contentType: string
  value?: string
  onChange: (changed: string) => void
  modelId?: string
  readOnly?: boolean
}

export default function DataModelSchemaStructure(props: DataModelSchemaStructureProps) {
  const [decodedContent, setDecodedContent] = useState('')
  const { readOnly = false } = props

  const handleOnChange = (changed: string) => {
    if (!readOnly) {
      props.onChange(safeBase64Encode(changed))
    }
  }

  // Handle X12 schema changes - X12SchemaManager already encodes the data
  const handleX12OnChange = (changed: string) => {
    if (!readOnly) {
      props.onChange(changed)
    }
  }

  useEffect(() => {
    if (props.value) {
      try {
        setDecodedContent(safeBase64Decode(props.value))
      } catch (error) {
        console.warn('Failed to decode structure value:', error)
        setDecodedContent('')
      }
    }
  }, [props.value])

  // Check if this is an X12 engine type
  const isX12Engine = props.contentType === 'application/EDI-X12'

  if (isX12Engine) {
    return (
      <X12SchemaGenerator
        value={props.value}
        onChange={handleX12OnChange}
        modelId={props.modelId}
        readOnly={readOnly}
      />
    )
  }

  return (
    <Card>
      <Card.Title>Provide the data schema structure</Card.Title>
      <Card.Subtitle>A schema structure defines a data model, e.i: XSD, JSON</Card.Subtitle>
      <Card.Separator />
      <Card.Body>
        <FileViewer
          contentType={props.contentType}
          content={decodedContent}
          options={{ readonly: readOnly }}
          onChange={readOnly ? undefined : handleOnChange}
        />
      </Card.Body>
    </Card>
  )
}
